import React from "react";
import { useNavigate } from "react-router-dom";

const NoCostModel = ({
  id,
  chipText = "How it Works",
  title = "Here's How We Do It At No Cost To You",
  buttonLink = "/signup",
}) => {
  const navigate = useNavigate();

  return (
    <div id={id} className="lg:max-w-[1440px] w-full mx-auto">
      <div className="w-full md:px-12 md:py-[64px] px-5 py-8">
        <div className="w-full mx-auto flex flex-col gap-4 md:gap-8 lg:gap-[64px]">
          <div className="flex flex-col gap-3 md:gap-4 lg:gap-6">
            <h5 className="bg-[#3CAB5C1A] text-[#3CAB5C] px-3 py-1 rounded-full border border-[#3CAB5C] font-medium w-fit">
              {chipText}
            </h5>

            <h2 className="font-medium w-full text-[#242424] text-[24px] md:text-[48px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0] text-left">
              {title}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
            <div className="bg-[#F8F9FB] p-8 md:p-12 rounded-[24px]">
              <h3 className="text-[#242424] text-[18px] md:text-[22px] font-medium mb-4">
                No In-House Techs
              </h3>
              <p className="text-[#595959] text-[18px] md:text-[22px] leading-relaxed">
                We have minimal overhead. No big offices, no company trucks, no
                in-house technicians. Our business model is based on vendor
                partnerships. This approach allows us to deliver Properteasy for
                free while ensuring every job is completed efficiently and
                reliably.
              </p>
            </div>

            <div className="bg-[#F8F9FB] p-8 md:p-12 rounded-[24px]">
              <h3 className="text-[#242424] text-[18px] md:text-[22px] font-medium mb-4">
                Vendor Partnerships
              </h3>
              <p className="text-[#595959] text-[18px] md:text-[22px] leading-relaxed">
                Sometimes, size does matter. We send a steady stream of work to
                our vendors. In return, they share profits with us, but you
                never pay more than if you called the vendor yourself. With
                Properteasy, you get the same price, without the hassle of
                finding and coordinating reliable vendors on your own.
              </p>
            </div>
          </div>

          <div>
            <button
              onClick={() => navigate(buttonLink)}
              className="bg-[#47C272] hover:bg-opacity-90 text-white font-medium text-[16px] py-3 px-6 rounded-[8px] transition-all"
            >
              Get Started for Free
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoCostModel;
